import { render, staticRenderFns } from "./students.vue?vue&type=template&id=0896d9fe&scoped=true"
import script from "./students.vue?vue&type=script&lang=js"
export * from "./students.vue?vue&type=script&lang=js"
import style0 from "./students.vue?vue&type=style&index=0&id=0896d9fe&prod&lang=less&scoped=true"
import style1 from "./students.vue?vue&type=style&index=1&id=0896d9fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0896d9fe",
  null
  
)

export default component.exports